import type {
  DeviceLogResourceListResponseApi,
  EnumDeviceLogStatusApi,
  EnumDeviceLogTypeApi,
  EnumLogFileTypeApi,
  LogFileApi,
} from '@ingenico/api-sdk-device-management-private-v2';
import { toString } from 'lodash-es';
import type { DeviceLogFile, DeviceLogsResponse } from '../../../model/deviceLogs.model';
import { DeviceLogFileType, DeviceLogStatus, DeviceLogType } from '../../../model/deviceLogs.model';

function mapDeviceLogType(types?: EnumDeviceLogTypeApi[]): DeviceLogType[] | undefined {
  return types?.map((type) => (type === 'APPLICATION' ? DeviceLogType.Application : DeviceLogType.System));
}

function mapDeviceLogStatus(status?: EnumDeviceLogStatusApi): DeviceLogStatus | undefined {
  switch (status) {
    case 'CANCELED': {
      return DeviceLogStatus.Canceled;
    }
    case 'FAILED': {
      return DeviceLogStatus.Failed;
    }
    case 'IN_PROGRESS': {
      return DeviceLogStatus.InProgress;
    }
    case 'COMPLETED': {
      return DeviceLogStatus.Completed;
    }
    case 'STOP_IN_PROGRESS': {
      return DeviceLogStatus.StopInProgress;
    }
    default: {
      return undefined;
    }
  }
}

function transformDurationToHours(duration?: number): number | undefined {
  return duration ? Math.round((duration / 3600) * 10) / 10 : duration;
}

function manageDeviceLogFileType(type?: EnumLogFileTypeApi): DeviceLogFileType | undefined {
  switch (type) {
    case 'APPLICATION_AND_SYSTEM': {
      return DeviceLogFileType.ApplicationAndSystem;
    }
    case 'MODEM': {
      return DeviceLogFileType.Modem;
    }
    default: {
      return undefined;
    }
  }
}

function mapDeviceLogFile(files?: LogFileApi[]): DeviceLogFile[] | undefined {
  return files?.map(({ filetype, ...file }) => ({ ...file, fileType: manageDeviceLogFileType(filetype) }));
}

export function mapSearchDeviceLogsResponse(response: DeviceLogResourceListResponseApi): DeviceLogsResponse {
  return {
    pagination: response.pagination,
    data: response.data.map(
      ({ deviceLogId, title, description, status, requestedDuration, startDate, types, logFiles }) => ({
        id: toString(deviceLogId),
        title,
        description,
        status: mapDeviceLogStatus(status),
        types: mapDeviceLogType(types),
        duration: transformDurationToHours(requestedDuration),
        startDate,
        files: mapDeviceLogFile(logFiles),
      }),
    ),
  };
}
